import get from 'lodash/get';
import pick from 'lodash/pick';
import assign from 'lodash/assign';
import map from 'lodash/map';

export const generateInitialEditpaylod = (product) => {
  const step1 = assign(
    pick(product, [
      'category_id_1',
      'category_id_2',
      'name',
      'sku',
      'gs1',
      'is_sample',
      'company_id',
    ]),
    {
      media: get(product, 'ProductResources'),
      category_id_3: get(product, 'category_id_3')
        ? get(product, 'category_id_3')
        : undefined,
      category_id_4: get(product, 'category_id_4')
        ? get(product, 'category_id_4')
        : undefined,
    }
  );

  const step2 = assign(
    pick(product, [
      'brand_name',
      'mrp',
      'manufacturer_name',
      'gst_cess',
      'gst_slab_id',
      'hsn_code',
      'storage_instructions',
    ]),
    {
      storage_instructions: get(product, 'storage_instructions')
        ? get(product, 'storage_instructions')
        : undefined,
      product_ingredient: map(
        get(product, 'ProductIngredients'),
        (ingredient) => ({
          id: get(ingredient, 'ProductIngredientType.id'),
          product_ingredient_type_id: get(
            ingredient,
            'ProductIngredientType.id'
          ),
          name: get(ingredient, 'ProductIngredientType.name'),
          amount: get(ingredient, 'amount'),
          product_unit_id: get(ingredient, 'product_unit_id'),
          percentage: get(ingredient, 'percentage'),
        })
      ),
      product_nutrition: map(get(product, 'ProductNutritions'), (nutri) => ({
        id: get(nutri, 'ProductNutritionType.id'),
        product_nutrition_type_id: get(nutri, 'ProductNutritionType.id'),
        name: get(nutri, 'ProductNutritionType.name'),
        amount: get(nutri, 'amount'),
      })),
    }
  );

  const step3 = assign(
    pick(product, [
      'country_id',
      'shelf_life_id',
      'product_shape_id',
      'color',
      'flavour',
      'weight_vol',
      'product_size_id',
      'packaging_id',
      'product_government_compliance',
    ]),
    {
      product_government_compliance: map(
        get(product, 'ProductGovernmentCompliances'),
        'government_compliance_id'
      ),
      product_property: map(get(product, 'ProductProperties'), (property) => ({
        id: get(property, 'ProductPropertyType.id'),
        product_property_type_id: get(property, 'ProductPropertyType.id'),
        name: get(property, 'ProductPropertyType.name'),
        value: get(property, 'value'),
      })),
    }
  );
  const step4 = pick(product, ['other_info']);

  return {
    step: 0,
    step1,
    step2,
    step3,
    step4,
  };
};

export const b = 1;
